import client from './client';
import type { Sale } from '@/types/api';

export interface CreateSaleRequest {
  productVariantId: string;
  locationId: string;
  quantity: number;
  salePrice: number;
  saleDate?: string;
  isPaidToLocation?: boolean;
  isPaymentReceived?: boolean;
  notes?: string;
}

export interface SaleSummary {
  totalRevenue: number;
  totalCommission: number;
  totalRetained: number;
}

export const salesApi = {
  getAll: async (): Promise<Sale[]> => {
    const response = await client.get<Sale[]>('/sales');
    return response.data;
  },

  getByLocation: async (locationId: string): Promise<Sale[]> => {
    const response = await client.get<Sale[]>(`/sales/location/${locationId}`);
    return response.data;
  },

  getByProduct: async (productId: string): Promise<Sale[]> => {
    const response = await client.get<Sale[]>(`/sales/product/${productId}`);
    return response.data;
  },

  getByDateRange: async (startDate: string, endDate: string): Promise<Sale[]> => {
    const response = await client.get<Sale[]>('/sales', {
      params: { startDate, endDate }
    });
    return response.data;
  },

  getUnpaidCommissions: async (): Promise<Sale[]> => {
    const response = await client.get<Sale[]>('/sales/unpaid-commissions');
    return response.data;
  },

  getTotalUnpaidCommissions: async (): Promise<number> => {
    const response = await client.get<number>('/sales/unpaid-commissions/total');
    return response.data;
  },

  create: async (data: CreateSaleRequest): Promise<Sale> => {
    const response = await client.post<Sale>('/sales', data);
    return response.data;
  },

  update: async (id: string, data: CreateSaleRequest): Promise<Sale> => {
    const response = await client.put<Sale>(`/sales/${id}`, data);
    return response.data;
  },

  markAsPaid: async (id: string): Promise<void> => {
    await client.post(`/sales/${id}/mark-paid`);
  },

  delete: async (id: string): Promise<void> => {
    await client.delete(`/sales/${id}`);
  },
};
